"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[594],{

/***/ 70064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ FavoriteLocationForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56580);
/* harmony import */ var _components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90836);
/* harmony import */ var _components_uielements_favoriteLocationsDropdownField_favorite_locations_dropdown_field__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68580);
/* harmony import */ var _components_uielements_forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8658);
/* harmony import */ var _components_uielements_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84247);
/* harmony import */ var _components_uielements_primaryButton_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25167);
/* harmony import */ var _redux_me_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47290);
/* harmony import */ var _redux_me_reducer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17426);










var disableFavLocationSaveButton = function(inputValue, locations) {
    if (!inputValue) {
        return true;
    }
    // Disable if we've selected a fave location that already exists
    return locations.some(function(location) {
        return location.id === +inputValue;
    });
};
var FavoriteLocationForm = function(param) {
    var onToggle = param.onToggle;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), inputValue = ref[0], setInputValue = ref[1];
    var favoriteLocations = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__.useSelector)(_redux_me_reducer__WEBPACK_IMPORTED_MODULE_9__/* .meSliceSelector */ .G).favoriteLocations;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__.useDispatch)();
    var submit = function(e) {
        e.preventDefault();
        dispatch(_redux_me_actions__WEBPACK_IMPORTED_MODULE_8__/* ["default"].addFavoriteLocation */ .Z.addFavoriteLocation(Number(inputValue)));
        onToggle();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_modal__WEBPACK_IMPORTED_MODULE_6__/* .Modal.Title */ .u.Title, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    accessor: "account.favorite_location_modal_header",
                    html: true
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_uielements_forms__WEBPACK_IMPORTED_MODULE_5__/* .StyledForm */ .Gq, {
                onSubmit: submit,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_uielements_modal__WEBPACK_IMPORTED_MODULE_6__/* .Modal.Content */ .u.Content, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_forms__WEBPACK_IMPORTED_MODULE_5__/* .StyledExplanationText */ .tM, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    accessor: "account.favorite_location_modal_subheader",
                                    html: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_favoriteLocationsDropdownField_favorite_locations_dropdown_field__WEBPACK_IMPORTED_MODULE_4__/* .FavoriteLocationDropdownField */ .K, {
                                handleChange: function(e) {
                                    return setInputValue(e.target.value);
                                },
                                width: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_uielements_modal__WEBPACK_IMPORTED_MODULE_6__/* .Modal.Footer */ .u.Footer, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_modal__WEBPACK_IMPORTED_MODULE_6__/* .Modal.Cancel */ .u.Cancel, {
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_primaryButton_styles__WEBPACK_IMPORTED_MODULE_7__/* .StyledPrimaryButton */ .D, {
                                type: "submit",
                                buttonTheme: "secondary",
                                disabled: disableFavLocationSaveButton(inputValue, /** @TODO ensure that `favoriteLocations` isn't null. */ // @ts-ignore
                                favoriteLocations),
                                children: "Save"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 99736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$3": function() { return /* binding */ StyledContactInfoContainer; },
/* harmony export */   "Dk": function() { return /* binding */ StyledInlineCancelAndSubmitButtons; },
/* harmony export */   "Gq": function() { return /* binding */ StyledForm; },
/* harmony export */   "JP": function() { return /* binding */ StyledTopLevelLoyaltyContainer; },
/* harmony export */   "Ji": function() { return /* binding */ StyledContactInfoContent; },
/* harmony export */   "Ll": function() { return /* binding */ StyledFormField; },
/* harmony export */   "Mo": function() { return /* binding */ StyledCancelEdit; },
/* harmony export */   "Pw": function() { return /* binding */ StyledFlexedHeader; },
/* harmony export */   "Qu": function() { return /* binding */ StyledSecondarySection; },
/* harmony export */   "UN": function() { return /* binding */ StyledLinkButton; },
/* harmony export */   "VX": function() { return /* binding */ StyledCancelAndSubmitButtons; },
/* harmony export */   "aN": function() { return /* binding */ StyledAccountContainer; },
/* harmony export */   "fb": function() { return /* binding */ StyledInlineFormContainer; },
/* harmony export */   "t9": function() { return /* binding */ StyledLoyaltyContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-3);\n  padding-top: var(--size-3);\n\n  @media (min-width: 768px) {\n    gap: var(--size-6);\n    padding-top: var(--size-6);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto;\n  max-width: ",
        "px;\n  padding: ",
        "px 0;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        "px;\n  margin: ",
        "px auto 0;\n\n  @media (max-width: 767px) {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  // to ensure first component never goes behind the loyalty nav\n  margin-top: ",
        "px;\n\n  @media (max-width: 767px) {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1 1 33.333%;\n  height: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  &:not(:first-child) {\n    padding-left: ",
        "px;\n\n    @media (max-width: 767px) {\n      padding-left: 0;\n    }\n  }\n\n  @media (max-width: 767px) {\n    flex-basis: 100%;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: right;\n  align-self: flex-end;\n\n  @media (max-width: 767px) {\n    display: flex;\n    flex-direction: column-reverse;\n    width: 100%;\n    margin: 0;\n\n    button {\n      width: 100%;\n    }\n\n    > div:first-child {\n      margin: ",
        "px 0 0 0;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  top: -20px;\n\n  @media (max-width: 767px) {\n    top: 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        "px;\n\n  p {\n    margin: ",
        "px 0;\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  @media (max-width: 767px) {\n    display: block;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-right: ",
        "px;\n  align-items: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  color: ",
        ";\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n\n  &:hover {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var StyledAccountContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-0"
})(_templateObject());
var StyledSecondarySection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-1"
})(_templateObject1(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.MAX_LOYALTY_CONTAINER_WIDTH */ ._.MAX_LOYALTY_CONTAINER_WIDTH, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER * 2);
var StyledLoyaltyContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-2"
})(_templateObject2(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.MAX_LOYALTY_CONTAINER_WIDTH */ ._.MAX_LOYALTY_CONTAINER_WIDTH, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.LOYALTY_MENU_HEIGHT_DESKTOP */ ._.LOYALTY_MENU_HEIGHT_DESKTOP, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE */ ._.LOYALTY_MENU_HEIGHT_MOBILE);
var StyledFlexedHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-3"
})(_templateObject3());
var StyledTopLevelLoyaltyContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-4"
})(_templateObject4(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.LOYALTY_MENU_HEIGHT_DESKTOP */ ._.LOYALTY_MENU_HEIGHT_DESKTOP, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE */ ._.LOYALTY_MENU_HEIGHT_MOBILE);
var StyledForm = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-495d45f5-5"
})(_templateObject5());
var StyledInlineFormContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-6"
})(_templateObject6());
var StyledFormField = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-7"
})(_templateObject7(), function(param) {
    var autoHeight = param.autoHeight, theme = param.theme;
    return autoHeight ? "auto" : "".concat(theme.forms.field_height + _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER, "px");
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledCancelAndSubmitButtons = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-8"
})(_templateObject8(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledInlineCancelAndSubmitButtons = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(StyledCancelAndSubmitButtons).withConfig({
    componentId: "sc-495d45f5-9"
})(_templateObject9());
var StyledContactInfoContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-10"
})(_templateObject10(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER / 4);
var StyledContactInfoContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-11"
})(_templateObject11());
var StyledCancelEdit = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-12"
})(_templateObject12(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledLinkButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-495d45f5-13"
})(_templateObject13(), function(param) {
    var bold = param.bold, theme = param.theme;
    return bold ? theme.primary_font.bold.font_family : theme.primary_font.regular.font_family;
}, function(param) {
    var theme = param.theme;
    return theme.global.primary_active_color;
});


/***/ }),

/***/ 93483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ LocationCard; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/locations/crossStreet/index.tsx
var crossStreet = __webpack_require__(48132);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/constants/styles.ts
var constants_styles = __webpack_require__(30438);
;// CONCATENATED MODULE: ./src/components/locations/ctas/menuCta/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 0 ",
        "px;\n  padding: 0 ",
        "px;\n  width: 100%;\n\n  @media (max-width: 767px) {\n    margin: ",
        "px auto 0;\n    width: 80%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-ec66c270-0"
})(_templateObject(), constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2);

// EXTERNAL MODULE: ./src/constants/events.ts
var events = __webpack_require__(26654);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(87809);
// EXTERNAL MODULE: ./src/utils/koalaAnalytics.ts + 1 modules
var koalaAnalytics = __webpack_require__(61216);
// EXTERNAL MODULE: ./src/utils/locations.ts + 2 modules
var locations = __webpack_require__(52591);
;// CONCATENATED MODULE: ./src/components/locations/ctas/menuCta/index.tsx








function MenuCta(param) {
    var location = param.location, label = param.label, favorites = param.favorites;
    var webConfig = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }).webConfig;
    // Determine whether we're accessing location card from homepage or Favorites
    var koalaAnalyticsLabel = favorites ? events/* K_ANALYTICS_EVENTS.LOCATION_FAVORITE_CTA */.AH.LOCATION_FAVORITE_CTA : events/* K_ANALYTICS_EVENTS.LOCATION_CTA */.AH.LOCATION_CTA;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/store/".concat((0,locations/* getLocationId */.By)(location, webConfig), "/").concat(location.label),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
            as: "a",
            buttonTheme: "primary",
            onClick: function() {
                (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.order */.m1.order, googleAnalytics/* gaActions.viewMenu */.cE.viewMenu, {
                    label: location.label
                });
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(koalaAnalyticsLabel, {
                    name: label
                });
            },
            children: label
        })
    });
}
/* harmony default export */ var ctas_menuCta = (MenuCta);

// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(80684);
;// CONCATENATED MODULE: ./src/components/locations/ctas/primaryCta/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 0 ",
        "px;\n  padding: 0 ",
        "px;\n  width: 100%;\n\n  ",
        "\n\n  @media (max-width: 767px) {\n    margin: ",
        "px auto 0;\n    width: 80%;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var styles_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-3faae05-0"
})(styles_templateObject(), constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, function(props) {
    return props.shouldHide && "\n    display: none;\n  ";
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2);

// EXTERNAL MODULE: ./src/analytics/events/index.ts + 4 modules
var analytics_events = __webpack_require__(45003);
// EXTERNAL MODULE: ./src/analytics/events/constants.ts
var constants = __webpack_require__(45048);
// EXTERNAL MODULE: ./src/constants/cssClassNames.ts
var cssClassNames = __webpack_require__(5733);
// EXTERNAL MODULE: ./src/constants/cta.ts
var cta = __webpack_require__(32159);
// EXTERNAL MODULE: ./src/redux/conveyanceMode/actions.ts
var actions = __webpack_require__(38534);
// EXTERNAL MODULE: ./src/redux/global/actions.ts
var global_actions = __webpack_require__(79118);
// EXTERNAL MODULE: ./src/utils/stringHelpers.ts
var stringHelpers = __webpack_require__(60738);
// EXTERNAL MODULE: ./src/utils/focusReturn.ts
var focusReturn = __webpack_require__(27658);
;// CONCATENATED MODULE: ./src/components/locations/ctas/primaryCta/index.tsx














var LocationCta = function(param) {
    var accessor = param.accessor, location = param.location, position = param.position, favorites = param.favorites;
    var ref = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }), webConfig = ref.webConfig, strings = ref.strings;
    var fulfillment = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.basket;
    }).fulfillment;
    var dispatch = (0,redux/* useDispatch */.I0)();
    var deriveFinalCtaValue = function(value) {
        var finalValue = (0,stringHelpers/* interpolateLocationCtaValue */.hF)(value, location, webConfig).finalValue;
        // If we have an existing delivery address AND the CTA is a delivery trigger, the CTA will be treated like a normal location link
        // however, since the value is still $deliveryCta$ we need to replace this with the path to the store menu page
        if (cta/* CTA.DELIVERY_URL */.M.DELIVERY_URL && (fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.address)) {
            finalValue = (0,stringHelpers/* interpolateLocationCtaValue */.hF)(cta/* CTA.PICKUP_URL */.M.PICKUP_URL, location, webConfig).finalValue;
        }
        return finalValue;
    };
    var globalValue = (0,stringHelpers/* safelyGetString */.bc)(strings, "location_ctas.".concat(accessor, "_value"), location);
    var globalLabel = (0,stringHelpers/* safelyGetString */.bc)(strings, "location_ctas.".concat(accessor, "_label"), location);
    var ref1 = (0,stringHelpers/* reconcileCustomAttributeWithGlobalValue */.zS)(// @ts-expect-error improve typing of custom attributes.
    location.attributes, position, globalValue, globalLabel), label = ref1.label, value = ref1.value;
    // Ensure we have both values before displaying cta
    if (!value || !label) {
        return null;
    }
    // If the location is not online and the CTA is directing to a Koala url, hide the CTA
    if (!location.provider_enabled && (value === cta/* CTA.DELIVERY_URL */.M.DELIVERY_URL || value === cta/* CTA.PICKUP_URL */.M.PICKUP_URL)) {
        return null;
    }
    // We should only render the Koala-specific delivery trigger if the location supports delivery. Otherwise, we should render nothing
    var hideDeliveryTrigger = !location.supports_delivery;
    // Derive button theme
    // TODO: improve this type and remove string type to narrow it to proper union type
    /** @TODO fix accessor reconciliation. */ // @ts-expect-error: cannot type due to lookup method
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    var buttonTheme = "".concat(webConfig.location_card["".concat(accessor, "_button_theme")]);
    // Determine whether we're accessing location card from homepage or Favorites
    var analyticsLabel = favorites ? constants/* GlobalEvents.LOCATIONS__FAVORITE_LOCATION_CTA */.x.LOCATIONS__FAVORITE_LOCATION_CTA : constants/* GlobalEvents.LOCATIONS__PRIMARY_LOCATION_CTA */.x.LOCATIONS__PRIMARY_LOCATION_CTA;
    /**
   * Primary and Secondary Location CTAs
   */ return(// If we have a deliveryUrl trigger BUT an address already exists in the basket,
    // do not trigger address validation - the cart reconciliation logic will handle
    // any different location revalidation that is needed on the menu page
    value === cta/* CTA.DELIVERY_URL */.M.DELIVERY_URL && !(fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.address) ? // If delivery button clicked AND there's no existing delivery address OR no items in the cart, trigger delivery modal
    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledButton, {
        size: "small",
        shouldHide: hideDeliveryTrigger,
        buttonTheme: buttonTheme,
        className: cssClassNames/* CSS_CLASSES.LOCATION_CARD.PICKUP_BUTTON */.Y.LOCATION_CARD.PICKUP_BUTTON,
        "aria-label": "".concat(label, " from ").concat(location.label),
        onClick: function(event) {
            (0,focusReturn/* setOpeningElement */.a3)(event.currentTarget);
            dispatch(global_actions/* default.toggleFulfillmentModal */.Z.toggleFulfillmentModal(true, location, dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY));
            // Events
            (0,analytics_events/* genericEventHandler */.O)(constants/* GlobalEvents.LOCATIONS__TRIGGER_DELIVERY_MODAL */.x.LOCATIONS__TRIGGER_DELIVERY_MODAL, {
                name: location.label,
                details: dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY
            });
        },
        children: label
    }) : // else render normal link to designated page
    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: deriveFinalCtaValue(value),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledButton, {
            className: cssClassNames/* CSS_CLASSES.LOCATION_CARD.PICKUP_BUTTON */.Y.LOCATION_CARD.PICKUP_BUTTON,
            as: "a",
            size: "small",
            shouldHide: value === cta/* CTA.DELIVERY_URL */.M.DELIVERY_URL && hideDeliveryTrigger,
            buttonTheme: buttonTheme,
            "data-testid": "link-button-pickup-order",
            "aria-label": "".concat(label, " from ").concat(location.label),
            onClick: function() {
                // Make sure Pickup CTA is always setting orders to Pickup
                if (value === cta/* CTA.PICKUP_URL */.M.PICKUP_URL) {
                    dispatch(actions/* default.clearDeliveryAddress */.Z.clearDeliveryAddress(location.id));
                    dispatch(actions/* default.conveyanceModeSet */.Z.conveyanceModeSet({
                        type: events/* API_CONVEYANCE_TYPES.PICKUP */.tQ.PICKUP,
                        details: []
                    }));
                }
                // Internal Delivery or Pickup button
                value === cta/* CTA.DELIVERY_URL */.M.DELIVERY_URL || value === cta/* CTA.PICKUP_URL */.M.PICKUP_URL ? (0,analytics_events/* genericEventHandler */.O)(analyticsLabel, {
                    name: location.label,
                    details: value === cta/* CTA.DELIVERY_URL */.M.DELIVERY_URL ? dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY : dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP
                }) : (0,analytics_events/* genericEventHandler */.O)(constants/* GlobalEvents.GENERIC__CTA */.x.GENERIC__CTA, {
                    name: location.label,
                    details: value
                });
            },
            children: label
        })
    }));
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ./node_modules/lodash/compact.js
var compact = __webpack_require__(39693);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/components/uielements/genericModal/index.tsx
var genericModal = __webpack_require__(85526);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
// EXTERNAL MODULE: ./src/utils/safePolished.ts
var safePolished = __webpack_require__(68902);
;// CONCATENATED MODULE: ./src/components/locations/ctas/secondaryCta/modal/index.tsx



function modal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px;\n"
    ]);
    modal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var SecondaryCtaModal = function(param) {
    var ctas = param.ctas, onToggle = param.onToggle, visible = param.visible;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(genericModal/* default */.Z, {
        modalOpen: visible,
        toggleModal: function() {
            return onToggle();
        },
        name: events/* MODAL.CTA_OVERFLOW */.zr.CTA_OVERFLOW,
        ariaLabel: "Location information",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSecondaryCtaModal, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    tag: "h1",
                    html: true,
                    accessor: "location_ctas.overflow_modal_headline"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    tag: "p",
                    html: true,
                    accessor: "location_ctas.overflow_modal_subheadline"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCtaList, {
                    children: ctas
                })
            ]
        })
    });
};
var StyledSecondaryCtaModal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-53693550-0"
})(modal_templateObject(), constants_styles/* LAYOUT.GUTTER */._.GUTTER * 2);
var StyledCtaList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-53693550-1"
})(function(param) {
    var theme = param.theme;
    return {
        "> a": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            background: theme.buttons.knockout_button_background_color,
            borderRadius: "".concat(theme.buttons.knockout_button_border_radius, "px"),
            border: "1px solid ".concat(theme.buttons.knockout_button_border_color),
            margin: "40px 0 0",
            padding: "15px",
            textAlign: "center",
            textDecoration: "none"
        }, (0,utils/* getFontStyles */.l)(theme.buttons.knockout_font, [
            "color",
            "font_family",
            "font_weight",
            "font_size",
            "line_height"
        ], {
            /** @FIXME font refactor. how will this work if primary_font.color is returned as inherit | initial | etc */ color: function(value) {
                return value !== null && value !== void 0 ? value : theme.buttons.knockout_button_border_color;
            }
        })), {
            "&:hover": {
                background: "transparent",
                borderColor: "".concat(theme.buttons.knockout_button_border_color ? (0,safePolished/* safePolished */.F)(polished_esm/* darken */._j)(0.025, theme.buttons.knockout_button_border_color) : "transparent")
            }
        })
    };
});
/* harmony default export */ var modal = (SecondaryCtaModal);

;// CONCATENATED MODULE: ./src/components/locations/ctas/secondaryCta/styles.ts

function secondaryCta_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: ",
        ";\n  font-family: ",
        ";\n  margin: 15px ",
        "px 0 0;\n  padding: 0;\n  text-align: left;\n  text-decoration: underline;\n"
    ]);
    secondaryCta_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledSecondaryButton = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-414fffdb-0"
})(secondaryCta_styles_templateObject(), function(param) {
    var shouldHide = param.shouldHide;
    return shouldHide ? "none" : "block";
}, function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER);

// EXTERNAL MODULE: ./src/constants/locations.ts
var constants_locations = __webpack_require__(56296);
;// CONCATENATED MODULE: ./src/components/locations/ctas/secondaryCta/index.tsx















var SecondaryCtaManager = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SecondaryCtaManager, Component);
    var _super = (0,_create_super/* default */.Z)(SecondaryCtaManager);
    function SecondaryCtaManager() {
        (0,_class_call_check/* default */.Z)(this, SecondaryCtaManager);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            secondaryCtaArray: [],
            showOverflowModal: false
        };
        _this.deriveSecondaryCtaArray = function() {
            return constants_locations/* SECONDARY_CTA_MAPPINGS.map */.HQ.map(function(ctaMap, index) {
                var _props = _this.props, strings = _props.strings, location = _props.location, favorites = _props.favorites;
                var globalValue = (0,stringHelpers/* safelyGetString */.bc)(strings, "location_ctas.".concat(ctaMap.accessor, "_value"), location);
                var globalLabel = (0,stringHelpers/* safelyGetString */.bc)(strings, "location_ctas.".concat(ctaMap.accessor, "_label"), location);
                var ref = (0,stringHelpers/* reconcileCustomAttributeWithGlobalValue */.zS)(// @ts-expect-error improve typing of custom attributes.
                location.attributes, ctaMap.position, globalValue, globalLabel), label = ref.label, value = ref.value;
                // Determine whether we're accessing location card from homepage or Favorites
                var koalaAnalyticsLabel = favorites ? events/* K_ANALYTICS_EVENTS.LOCATION_FAVORITE_CTA */.AH.LOCATION_FAVORITE_CTA : events/* K_ANALYTICS_EVENTS.LOCATION_CTA */.AH.LOCATION_CTA;
                // Ensure provider enabled and we have both values before displaying cta
                if (!location.provider_enabled || !value || !label) {
                    return null;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSecondaryButton, {
                    onClick: function() {
                        // GA event
                        (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.order */.m1.order, googleAnalytics/* gaActions.orderDelivery */.cE.orderDelivery, {
                            label: location.label
                        });
                        // Requested per: [KOALA-5979 Pass LOCATION_CTA event and name to Google Analytics](https://koalalabs.atlassian.net/browse/KOALA-5979)
                        (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.order */.m1.order, googleAnalytics/* gaActions.clickLocationCardTertiaryCta */.cE.clickLocationCardTertiaryCta, {
                            label: label
                        });
                        // KA event
                        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(koalaAnalyticsLabel, {
                            name: label,
                            details: value
                        });
                    },
                    href: value,
                    target: "_blank",
                    children: label
                }, index);
            });
        };
        return _this;
    }
    var _proto = SecondaryCtaManager.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // This assumes we've already fetched the strings via the server
        this.setState({
            // @ts-expect-error ensure that `deriveSecondaryCtaArray` isn't `null`.
            secondaryCtaArray: this.deriveSecondaryCtaArray()
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.setState({
                // @ts-expect-error ensure that `deriveSecondaryCtaArray` isn't `null`.
                secondaryCtaArray: this.deriveSecondaryCtaArray()
            });
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _state = this.state, secondaryCtaArray = _state.secondaryCtaArray, showOverflowModal = _state.showOverflowModal;
        var lengthOfValidCtas = compact_default()(secondaryCtaArray).length;
        // If 2 or more CTAs exist, trigger the consoliation modal
        if (lengthOfValidCtas > 2) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSecondaryButton, {
                        as: "button",
                        onClick: function() {
                            return _this.setState({
                                showOverflowModal: true
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "location_ctas.overflow_modal_trigger_label"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal, {
                        ctas: secondaryCtaArray,
                        visible: showOverflowModal,
                        onToggle: function() {
                            return _this.setState({
                                showOverflowModal: false
                            });
                        }
                    })
                ]
            });
        }
        // Otherwise, display the CTAs normally
        return secondaryCtaArray;
    };
    return SecondaryCtaManager;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        strings: state.app.cmsConfig.strings
    };
};
var connector = (0,es.connect)(mapStateToProps);
/* harmony default export */ var secondaryCta = (connector(SecondaryCtaManager));

;// CONCATENATED MODULE: ./src/components/locations/card/components.tsx



var _LocationConveyance = /*#__PURE__*/ (0,react.memo)(function(param) {
    var location = param.location, theme = param.theme;
    // Ensure support
    if (!theme.location_card.show_conveyance_types) {
        return null;
    }
    // Assemble conveyance types object
    var conveyanceObject = {
        Curbside: location.supports_curbside,
        Delivery: location.supports_delivery,
        "Drive Thru": location.supports_drive_thru,
        Pickup: location.supports_pick_up,
        "Dine In": location.supports_to_stay || location.supports_dine_in || location.supports_dine_in_table_number,
        "Drive In": location.supports_drive_in
    };
    // Cast supported conveyance types to array
    var conveyanceArray = Object.keys(conveyanceObject).filter(// @ts-expect-error `key` can't index `conveyanceObject`.
    function(key) {
        return conveyanceObject[key];
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: conveyanceArray.map(function(key, index) {
            return "".concat(key).concat(conveyanceArray.length - 1 !== index ? ", " : "");
        })
    });
});
var LocationConveyance = (0,styled_components_browser_esm/* withTheme */.Zz)(_LocationConveyance);

;// CONCATENATED MODULE: ./src/components/locations/card/styles.ts



function card_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: 1px solid\n    ",
        ";\n  border-radius: ",
        "px;\n  margin: 0 0 ",
        "px 0;\n  padding: ",
        "px;\n\n  // Only on Account page\n  ",
        "\n\n  // Store Location Card in Account 'Favorites' section\n  ",
        "\n\n  // TODO - fix\n  @media (max-width: 767px) {\n    ",
        "\n  }\n"
    ]);
    card_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: start;\n  display: flex;\n\n  @media (max-width: 767px) {\n    display: block;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  padding-left: ",
        "px;\n  text-align: center;\n\n  @media (max-width: 767px) {\n    padding-left: 0;\n    display: block;\n\n    a:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  font-family: ",
        ";\n\n  @media (max-width: 767px) {\n    display: block;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledLocationCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1fb26e90-0"
})(card_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.location_card.background_color;
}, function(param) {
    var isActive = param.isActive, theme = param.theme;
    return isActive ? theme.global.primary_active_color : theme.location_card.border_color;
}, function(param) {
    var theme = param.theme;
    return theme.location_card.border_radius;
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER, constants_styles/* LAYOUT.GUTTER */._.GUTTER, function(param) {
    var editFavoriteLocation = param.editFavoriteLocation;
    return editFavoriteLocation && "\n    position: relative;\n  ";
}, function(param) {
    var favorites = param.favorites;
    return favorites && "\n    width: calc(50% - ".concat(constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, "px);\n  ");
}, function(param) {
    var favorites = param.favorites;
    return favorites ? "\n      width: 100%;\n    " : "\n      z-index: ".concat(constants_styles/* ORDER.HEADER */.kl.HEADER, ";\n    ");
});
var StyledLocationCardFlex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1fb26e90-1"
})(_templateObject1());
var StyledCardInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1fb26e90-2"
})(function(param) {
    var theme = param.theme;
    return {
        flex: 2,
        div: {
            textAlign: "left",
            "@media (max-width: 767px)": {
                textAlign: "center"
            }
        },
        h3: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            display: "inline-block",
            margin: 0,
            position: "relative"
        }, (0,utils/* getFontStyles */.l)(theme.location_card.secondary_font, [
            "color",
            "font_family",
            "font_size",
            "font_style",
            "line_height", 
        ])), {
            "> button": {
                position: "absolute",
                top: 0,
                right: "-5px"
            }
        }),
        p: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            margin: "8px 0 0"
        }, (0,utils/* getFontStyles */.l)(theme.location_card.font)), {
            "@media (max-width: 767px)": {
                textAlign: "center"
            },
            b: {
                fontWeight: "bold"
            },
            a: {
                "&:hover": {
                    textDecoration: "underline"
                }
            }
        }),
        "@media (max-width: 767px)": {
            textAlign: "center"
        }
    };
});
var StyledCardLinks = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    "data-css-override": "StyledCardLinks"
}).withConfig({
    componentId: "sc-1fb26e90-3"
})(_templateObject2(), constants_styles/* LAYOUT.GUTTER */._.GUTTER);
var StyledDistance = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1fb26e90-4"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.primary_font.medium.font_family;
});

// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs + 4 modules
var react_dropdown_menu_dist = __webpack_require__(44428);
// EXTERNAL MODULE: ./src/components/account/accountInformation/favoriteLocation/form.tsx
var favoriteLocation_form = __webpack_require__(70064);
// EXTERNAL MODULE: ./src/components/uielements/icon/index.tsx + 20 modules
var icon = __webpack_require__(98414);
// EXTERNAL MODULE: ./src/components/uielements/modal/index.tsx + 9 modules
var uielements_modal = __webpack_require__(84247);
// EXTERNAL MODULE: ./src/redux/cmsConfig/index.ts
var cmsConfig = __webpack_require__(26738);
// EXTERNAL MODULE: ./src/redux/me/actions.ts
var me_actions = __webpack_require__(47290);
;// CONCATENATED MODULE: ./src/components/locations/favorite-location-actions.tsx

function favorite_location_actions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n"
    ]);
    favorite_location_actions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function favorite_location_actions_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  appearance: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n"
    ]);
    favorite_location_actions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function favorite_location_actions_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: ",
        ";\n  padding: var(--size-3);\n\n  text-decoration: none;\n\n  &:not(:first-child) {\n    border-top: 1px solid ",
        ";\n  }\n"
    ]);
    favorite_location_actions_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var FavoriteLocationActions = function(param) {
    var location = param.location;
    // in order to correctly use a menu and modal from radix, we have to split the
    // rendering and add some modal wiring
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var webConfig = (0,cmsConfig/* useWebConfig */.JR)();
    var required = webConfig.accounts.favorite_location === "required";
    var dispatch = (0,es.useDispatch)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dropdown_menu_dist/* Root */.fC, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Edit, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Ellipsis */.Z.Ellipsis, {
                            title: "Edit favorite location"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                onSelect: function() {
                                    return setShowModal(true);
                                },
                                children: "Edit Favorite Location"
                            }),
                            !required && /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                onSelect: function() {
                                    return dispatch(me_actions/* default.removeFavoriteLocation */.Z.removeFavoriteLocation(location.id, location.label));
                                },
                                children: "Delete Favorite Location"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements_modal/* Modal.Container */.u.Container, {
                onCancel: function() {
                    return setShowModal(false);
                },
                requestVisibility: showModal,
                children: function(toggle) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(favoriteLocation_form/* FavoriteLocationForm */.j, {
                        onToggle: function() {
                            toggle();
                            setShowModal(false);
                        }
                    });
                }
            })
        ]
    });
};
var Content = (0,styled_components_browser_esm/* default */.ZP)(react_dropdown_menu_dist/* Content */.VY).withConfig({
    componentId: "sc-d009734e-0"
})(favorite_location_actions_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.location_card.background_color, ";\n    border: 1px solid ").concat(theme.location_card.border_color, ";\n    border-radius: ").concat(theme.location_card.border_radius, "px;\n  ");
});
var Edit = (0,styled_components_browser_esm/* default */.ZP)(react_dropdown_menu_dist/* Trigger */.xz).withConfig({
    componentId: "sc-d009734e-1"
})(favorite_location_actions_templateObject1());
var Item = (0,styled_components_browser_esm/* default */.ZP)(react_dropdown_menu_dist/* Item */.ck).withConfig({
    componentId: "sc-d009734e-2"
})(favorite_location_actions_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
}, function(param) {
    var theme = param.theme;
    return theme.location_card.border_color;
});

// EXTERNAL MODULE: ./src/components/uielements/stack/stack.tsx + 2 modules
var stack = __webpack_require__(45866);
// EXTERNAL MODULE: ./src/features/menu/service.ts
var service = __webpack_require__(50019);
;// CONCATENATED MODULE: ./src/components/locations/card/index.tsx














var LocationCard = function(param) {
    var activeLocationId = param.activeLocationId, menuCta = param.menuCta, location = param.location, setActiveLocation = param.setActiveLocation, favorites = param.favorites, editFavoriteLocation = param.editFavoriteLocation;
    var ref, ref1, ref2;
    var prefetchMenu = (0,service/* usePrefetchMenu */.Uq)();
    var deriveLocationInfo = function(location) {
        var cached_data = location.cached_data;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInfo, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: cached_data === null || cached_data === void 0 ? void 0 : cached_data.label
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            "data-testid": "locations-card-address-container",
                            href: (0,locations/* googleMapsUrl */.Y_)(cached_data),
                            target: cached_data ? "_blank" : "_self",
                            rel: "noreferrer",
                            children: [
                                location.street_address,
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(crossStreet/* CrossStreet */.z, {
                                    crossStreetDetail: location.cross_street
                                }),
                                location.city,
                                ", ",
                                cached_data === null || cached_data === void 0 ? void 0 : cached_data.state,
                                " ",
                                location.zip_code
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "data-testid": "location-phone",
                            children: cached_data === null || cached_data === void 0 ? void 0 : cached_data.phone_number
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: (0,locations/* deriveTodaysHours */.he)(location, cached_data ? cached_data.utc_offset : 0)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationConveyance, {
                    location: location
                }),
                location.distance_miles && location.distance_miles > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDistance, {
                    children: [
                        Math.round(location.distance_miles * 100) / 100,
                        " miles away"
                    ]
                })
            ]
        });
    };
    if (!location) {
        return null;
    }
    var isUnavailableLocationMessageShown = !location.provider_enabled && (!((ref = location.attributes) === null || ref === void 0 ? void 0 : ref.length) || !((ref1 = location.attributes) === null || ref1 === void 0 ? void 0 : ref1.some(function(attr) {
        return attr.value && attr.label;
    })));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLocationCard, {
        // location card is not clickable on mobile map display
        className: "".concat(cssClassNames/* CSS_CLASSES.LOCATION_CARD.CONTAINER */.Y.LOCATION_CARD.CONTAINER, " ").concat(activeLocationId === location.id && "active"),
        /** @TODO it's not accessible to have an `onClick` on a div. Fix this. */ onClick: function() {
            // Warm the menu cache on select so the fetch overlaps navigation to the
            // store page instead of starting after it. (TEAM-13663)
            prefetchMenu(location.id);
            setActiveLocation === null || setActiveLocation === void 0 ? void 0 : setActiveLocation(location.id);
        },
        // Start warming as soon as the user signals intent (hover/keyboard focus).
        // react-query de-dupes and honours staleTime, so each location is fetched
        // at most once. (TEAM-13663)
        onMouseEnter: function() {
            return prefetchMenu(location.id);
        },
        onFocus: function() {
            return prefetchMenu(location.id);
        },
        role: "group",
        "aria-label": "Location: ".concat(location.label || ((ref2 = location.cached_data) === null || ref2 === void 0 ? void 0 : ref2.label)),
        isActive: activeLocationId === location.id,
        id: "Location-".concat(location.id),
        favorites: favorites,
        editFavoriteLocation: editFavoriteLocation,
        tabIndex: 0,
        "data-testid": "location-card-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLocationCardFlex, {
                children: [
                    deriveLocationInfo(location),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardLinks, {
                        children: [
                            menuCta && /*#__PURE__*/ (0,jsx_runtime.jsx)(ctas_menuCta, {
                                label: menuCta,
                                location: location,
                                favorites: favorites
                            }),
                            !menuCta && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationCta, {
                                        accessor: "primary",
                                        location: location,
                                        position: constants_locations/* LOCATION_ATTRIBUTE_POSITIONS.PRIMARY_ORDER_CTA */.NB.PRIMARY_ORDER_CTA,
                                        favorites: favorites
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationCta, {
                                        accessor: "secondary",
                                        location: location,
                                        position: constants_locations/* LOCATION_ATTRIBUTE_POSITIONS.SECONDARY_ORDER_CTA */.NB.SECONDARY_ORDER_CTA,
                                        favorites: favorites
                                    })
                                ]
                            }),
                            isUnavailableLocationMessageShown && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                        accessor: "locations.location_inactive",
                                        html: true
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            (!menuCta || editFavoriteLocation) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(stack/* Stack */.K, {
                position: "trailing",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(secondaryCta, {
                        location: location,
                        favorites: favorites
                    }),
                    editFavoriteLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteLocationActions, {
                        location: location
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 48132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ CrossStreet; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86879);


var CrossStreet = function(param) {
    var crossStreetDetail = param.crossStreetDetail;
    var crossStreetState = (0,_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.webConfig.locations.cross_street;
    });
    var crossStreetLabel = (0,_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.strings.locations.cross_street_label;
    });
    if (!crossStreetState || crossStreetDetail == null) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            crossStreetLabel && "".concat(crossStreetLabel, " "),
            crossStreetDetail,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
        ]
    });
};


/***/ }),

/***/ 68580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ FavoriteLocationDropdownField; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56580);
/* harmony import */ var _components_featureAccessor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88917);
/* harmony import */ var _components_uielements_form_fields_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73081);
/* harmony import */ var _components_uielements_selectCheckout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24274);
/* harmony import */ var _constants_features__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51710);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86879);
/* harmony import */ var _redux_locations_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17464);
/* harmony import */ var _utils_locations__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52591);
/* harmony import */ var _utils_magicBox__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39916);
/* harmony import */ var _utils_stringHelpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60738);












function FavoriteLocationDropdownField(param) {
    var handleChange = param.handleChange, input = param.input, meta = param.meta, width = param.width, errorMessage = param.errorMessage;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__.useDispatch)();
    var locations = (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.app.locations.list;
    });
    var favoriteLocationId = (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.app.me.favoriteLocationId;
    });
    var strings = (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.strings;
    });
    var webConfig = (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.webConfig;
    });
    var disabled = webConfig.accounts.favorite_location === "disabled";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!disabled) {
            // Assign magicbox parameters
            var magicBox = new _utils_magicBox__WEBPACK_IMPORTED_MODULE_10__/* .MagicBoxParams */ .t().setPagination(1, 50).setSorts({
                state_id: "asc",
                label: "asc"
            });
            // Fetch all locations
            dispatch(_redux_locations_actions__WEBPACK_IMPORTED_MODULE_8__/* .locationsActions.fetchAllLocations */ .b.fetchAllLocations(magicBox));
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_featureAccessor__WEBPACK_IMPORTED_MODULE_3__/* .FeatureAccessor */ .R, {
        featureFlag: _constants_features__WEBPACK_IMPORTED_MODULE_6__/* .FEATURE_FLAGS.ACCOUNT__FAVORITE_LOCATIONS_ENABLED */ .y8.ACCOUNT__FAVORITE_LOCATIONS_ENABLED,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_form_fields_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledFormField */ .Ll, {
            width: width,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_selectCheckout__WEBPACK_IMPORTED_MODULE_5__/* .ReduxFormSelect */ .v, {
                errorMessage: errorMessage,
                /** @TODO ensure that `name` is defined. */ // @ts-expect-error
                name: input === null || input === void 0 ? void 0 : input.name,
                handleChange: handleChange,
                optionsArray: (locations === null || locations === void 0 ? void 0 : locations.length) ? (0,_utils_locations__WEBPACK_IMPORTED_MODULE_9__/* .getLocationDataForDropdown */ .Zs)(locations) : [],
                title: (locations === null || locations === void 0 ? void 0 : locations.length) ? (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_11__/* .safelyGetString */ .bc)(strings, "account.add_favorite_location_header") : "Loading Locations...",
                loadingMessage: "Loading Locations...",
                /** @TODO differentiate between `null` and `undefined`. */ // @ts-expect-error
                defaultValue: favoriteLocationId ? favoriteLocationId.toString() : null,
                meta: meta,
                titleEnabled: true
            })
        })
    });
}


/***/ }),

/***/ 8658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gq": function() { return /* binding */ StyledForm; },
/* harmony export */   "hX": function() { return /* binding */ StyledPaddingContainer; },
/* harmony export */   "tM": function() { return /* binding */ StyledExplanationText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


/**
 * This file contains a bunch of catch-all style components for form elements.
 * As individual layouts are refactored, we should stop using these components
 * because they could be implemented out more easily using reusable layout
 * components.
 */ var StyledForm = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-8e6b048f-0"
})(_templateObject());
var StyledPaddingContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8e6b048f-1"
})(_templateObject1(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledExplanationText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-8e6b048f-2"
})(_templateObject2());


/***/ }),

/***/ 39916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ MagicBoxParams; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58408);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50361);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);





var MagicBox = /*#__PURE__*/ function() {
    "use strict";
    function MagicBox() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, MagicBox);
    }
    /**
   * Flatten an object and get paths to all its properties
   *
   * @param object
   * @param path
   * @param paths
   * @returns {*}
   * @TODO improve typing of `object` and `paths`.
   */ MagicBox.flatten = function flatten(object, path, paths) {
        for(var key in object){
            if (object.hasOwnProperty(key)) {
                if (typeof object[key] === "object") {
                    MagicBox.flatten(object[key], "".concat(path, ".").concat(key), paths);
                } else if (path !== "") {
                    paths[key] = "".concat(path.slice(1), ".").concat(key);
                } else {
                    paths[key] = key;
                }
            }
        }
        return paths;
    };
    /**
   * Build arbitrarily nested filters
   *
   * @param filters
   * @param key
   * @returns {Array}
   * @TODO improve typing of `filters`.
   */ MagicBox.buildFilters = function buildFilters(filters, key) {
        // Flatten the filters object to retrieve an object of {column_name: 'path.in.original.object'
        var flattened = MagicBox.flatten(filters, "", {});
        var filterStrings = [];
        for(var column in flattened){
            if (flattened.hasOwnProperty(column)) {
                // Remove column name from path, replace ORs and ANDs
                var orString = flattened[column].toLowerCase().replace(column, "").replace(/or\./g, "[or]").replace(/and\./g, "[and]");
                // Find the filter's value by the retrieved path
                var filter = orString.length === 0 ? filters[column] : lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(filters, flattened[column].replace(column, ""))[column];
                // Build the query param part
                filterStrings.push("".concat(key + orString, "[").concat(column, "]=").concat(filter));
            }
        }
        return filterStrings;
    };
    /**
   * Build a query string (of modifiers) such as per_page, filter, etc
   *
   * Modifiers can look like:
   * const modifiers = {
   * 		filters: {
   * 		    foo: '=bar',
   * 		    or : {
   * 		        baz            : 'bat',
   * 		        'relation.attr': '[1,2,3]'
   * 		    }
   * 		},
   * 		sort   : {
   * 		    'foo': 'asc'
   * 		},
   * 		include: [
   * 		    'foo.bar',
   * 		    'baz.bat',
   * 		]
   * 	};
   *
   * @param {object} modifiers
   * @returns {string}
   * @TODO improve the typing of `modifiers`.
   */ MagicBox.buildUrlModifiers = function buildUrlModifiers(modifiers) {
        var _loop = function(key) {
            // Handle filters and sorts as php assoc. arrays ['key' => 'value']
            if (key === "filters") {
                parts = parts.concat(MagicBox.buildFilters(modifiers[key], key));
            } else if (key === "sort" || key === "aggregate") {
                var part = modifiers[key];
                for(var column in part){
                    if (part.hasOwnProperty(column)) {
                        parts.push("".concat(key, "[").concat(column, "]=").concat(part[column]));
                    }
                }
            } else if (key === "include") {
                // @ts-expect-error
                modifiers[key].forEach(function(relation) {
                    parts.push("include[]=".concat(relation));
                });
            } else {
                // Handle others as objects to be serialized
                parts.push(MagicBox.serialize(modifiers[key]));
            }
        };
        var parts = [];
        for(var key in modifiers)_loop(key);
        if (parts.length > 0) {
            return parts.join("&");
        }
        return "";
    };
    /**
   * Serialize an object into a string of query parameters. This does not return the beginning ?.
   *
   * @param object
   * @returns {string}
   */ MagicBox.serialize = function serialize(object) {
        var parts = [];
        for(var param in object){
            if (object.hasOwnProperty(param)) {
                parts.push("".concat(encodeURIComponent(param), "=").concat(encodeURIComponent(object[param])));
            }
        }
        return parts.join("&");
    };
    /**
   * Break apart a query string into an object
   *
   * @param queryString
   * @returns {{}}
   */ MagicBox.deserialize = function deserialize(queryString) {
        var pairs = queryString.split("&");
        var params = {};
        pairs.forEach(function(pair) {
            var p = pair.split("=");
            params[p[0]] = decodeURIComponent(pair[1] || "");
        });
        return params;
    };
    return MagicBox;
}();
/**
 * A MagicContainer clones itself to prevent weird javascript stuff
 */ var MagicContainer = /*#__PURE__*/ function() {
    "use strict";
    function MagicContainer() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, MagicContainer);
    }
    var _proto = MagicContainer.prototype;
    _proto.clone = function clone() {
        return lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0___default()(this);
    };
    return MagicContainer;
}();
/**
 * MagicBoxParams is a container for filters, includes, sorts, pagination which get
 * passed to a MagicBox API.
 */ var MagicBoxParams = /*#__PURE__*/ function(MagicContainer) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(MagicBoxParams, MagicContainer);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(MagicBoxParams);
    function MagicBoxParams(filters, sort, include, page, perPage) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, MagicBoxParams);
        var _this;
        _this = _super.call(this);
        _this.without_pagination = false;
        _this.filters = filters || {};
        _this.sort = sort || {};
        _this.include = include || [];
        _this.page = page || 1;
        _this.per_page = perPage || 20;
        return _this;
    }
    var _proto = MagicBoxParams.prototype;
    /**
   * Get the modifier object
   *
   * @returns {object}
   */ _proto.modifiers = function modifiers() {
        return Object.assign({}, {
            filters: this.filters,
            sort: this.sort,
            include: this.include
        });
    };
    /**
   * Get the query for the modifier params
   *
   * @returns {string}
   */ _proto.modifierQuery = function modifierQuery() {
        return MagicBox.buildUrlModifiers(this.modifiers());
    };
    /**
   * Get a pagination object
   *
   * @returns {object}
   */ _proto.pagination = function pagination() {
        return Object.assign({}, {
            page: this.page,
            per_page: this.per_page
        });
    };
    /**
   * Get a pagination query
   *
   * @returns {string}
   */ _proto.paginationQuery = function paginationQuery() {
        return MagicBox.serialize(this.pagination());
    };
    /**
   * Turn a MagicBoxParams container into a query string
   *
   * @returns {string}
   */ _proto.toQuery = function toQuery() {
        var modQ = this.modifierQuery();
        if (!modQ) {
            return this.without_pagination ? "" : this.paginationQuery();
        }
        return this.without_pagination ? "".concat(modQ) : "".concat(modQ, "&").concat(this.paginationQuery());
    };
    /**
   * Set pagination options
   *
   * @param {number} page
   * @param {number} per_page
   * @returns {MagicBoxParams}
   */ _proto.setPagination = function setPagination(page, perPage) {
        this.page = page;
        this.per_page = perPage;
        return this;
    };
    /**
   * Set the filters object
   *
   * @param {object} filters
   * @returns {MagicBoxParams}
   */ _proto.setFilters = function setFilters(filters) {
        /** @TODO improve the typing of `filters`. */ // @ts-expect-error
        this.filters = filters;
        return this;
    };
    /**
   * Add a single filter
   *
   * @param {string} key
   * @param {string} value
   * @returns {MagicBoxParams}
   */ _proto.addFilter = function addFilter(key, value) {
        /** @TODO improve the typing of `filters`. */ // @ts-expect-error
        this.filters[key] = value;
        return this;
    };
    /**
   * Set the sort object
   *
   * @param {object} sort
   * @returns {MagicBoxParams}
   */ _proto.setSorts = function setSorts(sort) {
        /** @TODO improve the typing of `sort`. */ // @ts-expect-error
        this.sort = sort;
        return this;
    };
    /**
   * Add a single sort
   *
   * @param {string} key
   * @param {string} dir
   * @returns {MagicBoxParams}
   */ _proto.addSort = function addSort(key, dir) {
        /** @TODO improve the typing of `sort`. */ // @ts-expect-error
        this.sort[key] = dir;
        return this;
    };
    /**
   * Set the include object
   *
   * @param {string[]} include
   * @returns {MagicBoxParams}
   */ _proto.setIncludes = function setIncludes(include) {
        this.include = include;
        return this;
    };
    /**
   * Add a single include
   *
   * @param {string} include
   */ _proto.addInclude = function addInclude(include) {
        this.include.push(include);
    };
    /**
   * Ignore pagination
   */ _proto.withoutPagination = function withoutPagination() {
        this.without_pagination = true;
        return this;
    };
    return MagicBoxParams;
}(MagicContainer);



/***/ })

}]);